import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../LoadingError/Loading";
import Toast from "../LoadingError/Toast";
import MainPanel from "../main-panel/MainPanel";
import Message from "../LoadingError/Error";
import { Box, Button, Checkbox, Flex, FormControl, FormLabel, Heading, Image, Input, Stack, Text } from "@chakra-ui/react";
import { SLIDER_CLEAR } from "../../Redux/Constants/SliderConstans";
import { SliderAdd } from "../../Redux/Actions/SliderAction";
import { BASE_URL, PICTURE_URL } from "../../api/BaseConfig";
import axios from "axios";

const ToastObjects = {
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: false,
    autoClose: 2000,
};

const AddSliderMain = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const languageList = [
        { id: 1, langKey: "AZ" },
        { id: 2, langKey: "GB" },
        { id: 3, langKey: "RU" },
    ];

    const [status, setStatus] = useState(false);
    const [language, setLanguage] = useState([]);
    const [photoUrl, setPhotoUrl] = useState("");
    const [imageTitle, setImageTitle] = useState("");
    const [imageAlt, setImageAlt] = useState("");

    const handlePicture = (e) => {
        let data = new FormData();
        data.append("file", e, e.name);

        axios
            .post(BASE_URL + "/file", data, {
                headers: {
                    accept: "application/json",
                    "Accept-Language": "en-US,en;q=0.8",
                    "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
                },
            })
            .then((x) => {
                setPhotoUrl(x.data);
            })
            .catch((err) => alert(err));
    };
    const onHandleLangChange = useCallback((dataInfo) => {
        let languageList = {
            name: dataInfo.name,
            description: dataInfo.description,
            seoTitle: dataInfo.seoTitle,
            seoDescription: dataInfo.seoDescription,
            languageKey: dataInfo.lang,
        };
        setLanguage((ln) => [
            ...ln.filter(
                (l) => l.languageKey !== dataInfo.lang && l.languageKey !== ""
            ),
            languageList,
        ]);
    }, []);
    const sliderCreate = useSelector((state) => state.sliderAdd);
    const { loading, error, slider } = sliderCreate;

    useEffect(() => {
        if (slider) {
            toast.success("Slider successfully added!", ToastObjects);
            setTimeout(() => {
                dispatch({ type: SLIDER_CLEAR });
                setStatus();
                setPhotoUrl("");
                setImageTitle("");
                setImageAlt("");
                history.push("/sliders");
            }, 2000);
        }
    }, [slider, dispatch, history]);



  const submitHandler = (e) => {
    e.preventDefault();
    try {
      dispatch(
        SliderAdd({
          sliderRecord: language,
          status,
          photoUrl,
          imageTitle,
          imageAlt,
        })
      );
    //   toast.success("Slider successfully added!", ToastObjects);
      setTimeout(() => {
        history.push("/sliders");
      }, 2000); 
    } catch {
      toast.error("Failed to add Slider", ToastObjects);
    }
  };
  

    return (
        <>
            <Toast />
            <Box maxW="1200px" mx="auto" p={6}>
                <form onSubmit={submitHandler}>
                    {/* Header Section */}
                    <Flex justify="space-between" align="center" mb={8}>
                        <Button
                            as={Link}
                            to="/sliders"
                            colorScheme="red"
                            variant="solid"
                            _hover={{
                                backgroundColor: "red.600",
                                color: "white",
                            }}
                        >
                            Go to Sliders
                        </Button>


                        <Heading as="h2" size="lg" color="teal.600">
                            Add Slider
                        </Heading>
                        <Button type="submit" colorScheme="teal">
                            Publish Now
                        </Button>
                    </Flex>

                    {/* Form Section */}
                    <Box bg="white" p={8} borderRadius="lg" shadow="md">
                        {/* Language Input */}
                        <MainPanel
                            mainLang={languageList}
                            changeLang={onHandleLangChange}
                            languageInfo={language}
                        />

                        {/* Error & Loading */}
                        {error && <Message variant="alert-danger">{error}</Message>}
                        {loading && <Loading />}

                        {/* Status Checkbox */}
                        <FormControl mb={6}>
                            <Text fontSize="lg" fontWeight="semibold">
                                Status
                            </Text>
                            <Checkbox
                                size="lg"
                                colorScheme="teal"
                                isChecked={status}
                                onChange={(e) => setStatus(e.target.checked)}
                            >
                                Active
                            </Checkbox>
                        </FormControl>
                        <FormControl mb={4}>
                            <Input
                                type="file"
                                required
                                onChange={(e) => handlePicture(e.target.files[0])}
                            />
                            <FormLabel>Images</FormLabel>
                            {photoUrl && (
                                <Box mt={3} maxWidth="300px" maxHeight="250px" overflow="hidden">
                                    <Image
                                        src={PICTURE_URL + photoUrl}
                                        alt="Uploaded Image"
                                        objectFit="cover"
                                        width="100%"
                                        height="100%"
                                    />
                                </Box>
                            )}
                        </FormControl>
                        <FormControl mb={4}>
                            <FormLabel htmlFor="image_title">Image Title</FormLabel>
                            <Input
                                type="text"
                                id="image_title"
                                value={imageTitle}
                                onChange={(e) => setImageTitle(e.target.value)}
                                placeholder="Enter image title"
                            />
                        </FormControl>

                        <FormControl mb={4}>
                            <FormLabel htmlFor="image_alt">Image Alt Text</FormLabel>
                            <Input
                                type="text"
                                id="image_alt"
                                value={imageAlt}
                                onChange={(e) => setImageAlt(e.target.value)}
                                placeholder="Enter image alt text"
                            />
                        </FormControl>
                    </Box>
                </form>
            </Box>
        </>
    );
};

export default AddSliderMain;
